import Vue from 'vue';
import DeviceSensorTime from '@/components/devices-template/DeviceSensorTime';
import DeviceSwitchEnable from '@/components/devices-template/DeviceSwitchEnable';
import DeviceSwitchDisabled from '@/components/devices-template/DeviceSwitchDisabled';
import DeviceStatus from "@/components/devices-template/DeviceStatus";
import DeviceTitle from '@/components/devices-template/DeviceTitle';
import TimeField from "@/components/form/TimeField";
import ScenarioStatus from "@/components/scenarios-template/ScenarioStatus";
import ScenarioGroupStatus from "@/components/scenarios-template/ScenarioGroupStatus";

Vue.component('device-sensor-time', DeviceSensorTime);
Vue.component('device-switch-enable', DeviceSwitchEnable);
Vue.component('device-switch-disabled', DeviceSwitchDisabled);
Vue.component('device-status', DeviceStatus);
Vue.component('device-title', DeviceTitle);
Vue.component('time-field', TimeField);
Vue.component('scenario-status', ScenarioStatus);
Vue.component('scenario-group-status', ScenarioGroupStatus);